import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

document.addEventListener("DOMContentLoaded", function () {
  const swiperElements = document.querySelectorAll(".showcase-swiper");

  if (swiperElements.length > 0) {
    swiperElements.forEach((element) => {
      const slidesCount = element.querySelectorAll(".swiper-slide").length;

      // Initialize Swiper with responsive autoHeight
      const swiper = new Swiper(element, {
        modules: [Navigation, Autoplay],
        navigation: {
          nextEl: element.querySelector(".swiper-button-next"),
          prevEl: element.querySelector(".swiper-button-prev"),
        },
        loop: false,
        // Set initial autoHeight based on current window width
        autoHeight: window.innerWidth < 768,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            centeredSlides: true,
          },
          768: {
            slidesPerView: 2,
            centeredSlides: false,
            slideToClickedSlide: true,
          },
          1024: {
            slidesPerView: slidesCount <= 2 ? 2 : "auto",
            spaceBetween: 0,
            centeredSlides: false,
            slideToClickedSlide: true,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            watchSlidesProgress: true,
          },
        },
        // Add event listener to handle resizing
        on: {
          resize: function () {
            // 'this' refers to the swiper instance
            const isMobile = window.innerWidth < 768;
            // Only update if the state needs to change
            if (this.params.autoHeight !== isMobile) {
              this.params.autoHeight = isMobile;
              this.update(); // Apply the change
            }
          },
        },
      });
    });
  }
});
